import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth';
import { api } from '../api';

export function OAuthCallback() {
  const navigate = useNavigate();
  const { setToken, setUser } = useAuthStore();

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const token = params.get('token');

    if (!token) {
      navigate('/');
      return;
    }

    setToken(token);

    api
      .getMe()
      .then((data) => {
        setUser(data.role as 'guest' | 'user' | 'admin', data.user || null);
        if (data.role === 'admin') {
          navigate('/admin');
        } else {
          navigate('/');
        }
      })
      .catch(() => {
        navigate('/');
      });
  }, [setToken, setUser, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="mb-4 inline-block h-8 w-8 animate-spin rounded-full border-4 border-indigo-500 border-t-transparent"></div>
        <p className="text-slate-600 dark:text-star-dim">登录中...</p>
      </div>
    </div>
  );
}
